import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { resetPasswordWithToken } from '../services/api';
import { useToast } from '../components/ToastContainer';
import ToastContainer from '../components/ToastContainer';
import AuthLayout from '../components/AuthLayout';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { showToast, removeToast, toasts } = useToast();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    if (!token || !email) {
      setError('Nevalidan link. Koristite link iz email poruke.');
    }
  }, [token, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Lozinka mora imati najmanje 6 karaktera.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Lozinke se ne podudaraju.');
      return;
    }

    setIsLoading(true);
    try {
      const result = await resetPasswordWithToken(email, token, password);
      if (result.success) {
        setSuccess(true);
        showToast(result.message || 'Lozinka je uspešno promenjena.', 'success', 3000);
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message || 'Greška pri resetovanju lozinke.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!token || !email) {
    return (
      <AuthLayout title="Reset lozinke" subtitle="Postavite novu lozinku">
        <ToastContainer toasts={toasts} removeToast={removeToast} />
        <div className="card p-8">
          <p className="text-red-600 dark:text-red-400 mb-4">{error}</p>
          <Link to="/login" className="btn-primary inline-block">
            Nazad na prijavu
          </Link>
        </div>
      </AuthLayout>
    );
  }

  if (success) {
    return (
      <AuthLayout title="Reset lozinke" subtitle="Postavite novu lozinku">
        <ToastContainer toasts={toasts} removeToast={removeToast} />
        <div className="card p-8 text-center">
          <p className="text-green-600 dark:text-green-400 mb-4">
            Lozinka je uspešno promenjena. Preusmeravanje na prijavu...
          </p>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset lozinke" subtitle="Unesite novu lozinku">
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      <div className="card p-8">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1.5 text-gray-900 dark:text-gray-100">
              Nova lozinka
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="input-base"
              placeholder="Min. 6 karaktera"
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5 text-gray-900 dark:text-gray-100">
              Potvrdi lozinku
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              className="input-base"
              placeholder="Ponovo unesite lozinku"
              autoComplete="new-password"
            />
          </div>
          {error && (
            <div className="p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-sm text-red-700 dark:text-red-300">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary w-full disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <>
                <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                Čuvanje...
              </>
            ) : (
              'Postavi novu lozinku'
            )}
          </button>
          <p className="text-sm text-center">
            <Link to="/login" className="text-primary-600 dark:text-primary-400 hover:underline">
              Nazad na prijavu
            </Link>
          </p>
        </form>
      </div>
    </AuthLayout>
  );
}
